(function () {
    "use strict";
    
    var UserEditorDialog = $app.defineClass(
        "SolovisGateway.Admin.Users.UserEditorDialog",
        null,
        function (options) {
            var self = this;

            var desiredWidth = Math.min($(window).width() * .8, 750);
            var desiredHeight = Math.min($(window).height() * .8, 350);

            var minWidth = 100;
            var minHeight = 100;

            this._saveCallback = options.saveCallback ? options.saveCallback : null;
            this._userId = options.userId ? options.userId : null;
            this._isAdminUIRestricted = options.isAdminUIRestricted ? options.isAdminUIRestricted : false;
            this._hideRequireMfa = options.hideRequireMfa ? options.hideRequireMfa : false;

            var editorDiv = $("<div>")
                .css("min-height", "75px");

            this._userEditor = new SolovisGateway.Admin.Users.UserEditorControl({
                controlHost: editorDiv,
                userId: this._userId,
                isAdminUIRestricted: this._isAdminUIRestricted,
                hideRequireMfa: this._hideRequireMfa,
            });

            this._userEditor.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: this._userId ? "Edit User" : "Add User",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Save",
                        click: function () {
                            self._save();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }
    );

    UserEditorDialog.prototype._cancel = function () {
        this._dialogWindow.close();
    };

    UserEditorDialog.prototype._save = function () {
        var self = this;

        if (this._userEditor.isValid()) {

            var model = this._userEditor._getUserModel();
            $app.Rpc.invokeAndWait("~/Admin/UserAdmin/SetUser",
                {
                    model: model
                },
                function (response, success) {
                    if (success) {
                        if (response.result.modelIsValid) {
                            var savedUserEditorModel = response.result.modelResult;
                            // Only show notification when adding a new user.
                            var showNotification = self._userId ? false : true;
                            self._userEditor._savedUserEditorModel = {
                                userId: savedUserEditorModel.id
                            };

                            if (showNotification) {
                                self._userEditor.notify({
                                    success: true
                                });

                                var saveButton = self._dialogWindow.getButtonByLabel("Save");
                                if (saveButton) {
                                    saveButton
                                        .text("OK")
                                        .unbind("click")
                                        .click(function() {
                                            self._dialogWindow.close();
                                            if (self._saveCallback) {
                                                self._saveCallback(savedUserEditorModel);
                                            }
                                        });
                                }

                                var cancelButton = self._dialogWindow.getButtonByLabel("Cancel");
                                if (cancelButton) {
                                    cancelButton.remove();
                                }
                            }
                            else {
                                self._dialogWindow.close();
                                if (self._saveCallback) {
                                    self._saveCallback(savedUserEditorModel);
                                }
                            }

                        }
                        else {
                            self._userEditor._formBuilder.applyErrors(response.result.errors);
                        }
                    }
                });
        }
    };

    UserEditorDialog.showDialog = function (options) {
        var dialog = new SolovisGateway.Admin.Users.UserEditorDialog(options);
    }

})();